var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13195 1C3.66583 1 1.66663 2.9792 1.66663 5.42068C1.66663 7.39167 2.44776 12.0693 10.1396 16.7986C10.4181 16.9699 10.7764 16.9699 11.055 16.7986C18.7468 12.0693 19.5279 7.39167 19.5279 5.42068C19.5279 2.9792 17.5287 1 15.0626 1C12.5965 1 10.5973 3.6792 10.5973 3.6792C10.5973 3.6792 8.59808 1 6.13195 1V1Z",
    stroke: "#EB5757",
    strokeWidth: 1.3396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartUnfilled);
export default __webpack_public_path__ + "static/media/heartUnfilled.30f13b2d38d899607e51bce25a263995.svg";
export { ForwardRef as ReactComponent };